import { css } from '@emotion/css';
import { createTheme, type MantineTheme, Menu } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

const styles = {
  itemHover: () => css`
    &:hover {
      background-color: var(--mantine-color-purple-1) !important;
    }
  `,
};

export const ThemedMantineMenu: PartialDeep<MantineTheme> = createTheme({
  components: {
    Menu: Menu.extend({
      styles: theme => ({
        dropdown: {
          borderColor: theme.colors.gray[2],
          borderWidth: 1,
          boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.06)',
          borderRadius: 8,
          paddingVertical: 8,
        },
        divider: {
          backgroundColor: theme.colors.gray[2],
        },
      }),
      classNames: () => ({
        item: styles.itemHover(),
      }),
    }),
    MenuItem: Menu.Item.extend({
      defaultProps: { color: 'var(--mantine-color-gray-10)', style: { cursor: 'pointer' } },
    }),
  },
});
